import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { SimulationConfig } from '@/types';

interface SimulationHeaderProps {
  config: SimulationConfig;
  currentRgb: string;
  ballCount: number;
  ringsLeft: number;
  bounceCount: number;
  isEscape: boolean;
}

export const SimulationHeader: React.FC<SimulationHeaderProps> = ({ config, currentRgb, ballCount, ringsLeft, bounceCount, isEscape }) => {
  const showBadge = config.showStatusBadge && config.mode !== 'SPACE_SPIRAL' && config.mode !== 'SPAWNER' && !(isEscape && (config.ringCounterStyle === 'CENTER' || config.escapeTimeChallengeMode));
  const title = config.titleText;

  if (!title && !showBadge) return null;

  return (
    <div className="absolute top-8 left-0 right-0 pointer-events-none text-center z-10 px-4 flex flex-col items-center gap-3">
      <AnimatePresence mode="wait">
        {title && (
          <motion.h1 
            key={title}
            initial={{ opacity: 0, y: -20, filter: 'blur(10px)' }}
            animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            exit={{ opacity: 0, y: 20, filter: 'blur(10px)' }}
            className="uppercase tracking-[0.2em] font-medium transition-colors duration-500" 
            style={{ 
              color: config.rgbLighting ? currentRgb : config.titleColor,
              fontSize: `${config.titleFontSize}px`,
              fontFamily: config.titleFontFamily,
              fontWeight: config.titleFontWeight
            }}
          >
            {title}
          </motion.h1>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showBadge && (
          <motion.div 
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className={`${config.darkMode ? 'dark-hardware-surface text-white' : 'hardware-surface text-zinc-950'} glow-active inline-flex items-center gap-2 px-5 py-1.5 text-[9px] font-medium uppercase tracking-[0.2em] transition-all duration-300`} 
            style={{ 
              color: config.rgbLighting ? currentRgb : (config.darkMode ? 'white' : 'black'),
              borderColor: config.rgbLighting ? currentRgb : (config.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)')
            }}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-current animate-pulse" />
            <span id="header-status-text">
              {config.mode === 'ESCAPE' ? `${ringsLeft} Rings Left` : `${bounceCount} Bounces`}
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
